import { render, staticRenderFns } from "./ExportSegment.vue?vue&type=template&id=2e0fb9a0&scoped=true"
import script from "./ExportSegment.vue?vue&type=script&lang=js"
export * from "./ExportSegment.vue?vue&type=script&lang=js"
import style0 from "./ExportSegment.vue?vue&type=style&index=0&id=2e0fb9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0fb9a0",
  null
  
)

export default component.exports